import { googleMapsLoader } from "../google_maps_loader"

let predictionMapper = ({ placeId, text }) => {
  // Extract just the submarket name (first part before comma).
  // FormattableText.toString() is unreliable depending on how Maps JS loaded
  // (returns undefined even on current versions); read `.text`, fall back to toString().
  const fullText = text?.text || text?.toString?.() || ""
  const submarketName = fullText.split(",")[0].trim()

  return {
    data: { place_id: placeId, name: submarketName },
    optionText: fullText, // Show full address in dropdown
    selectionText: submarketName, // Show just submarket name when selected
    imageUrl: null,
  }
}

export const submarketSelector = {
  mounted() {
    // Ensure input is disabled when mounting
    this.el.querySelector("input")?.setAttribute("disabled", true)

    const extraParams = JSON.parse(this.el.dataset.extraParams || "{}")

    this.el.addEventListener("autocomplete:item-select", (e) => {
      this.pushEventTo(
        this.el,
        this.el.dataset.onSelect,
        Object.assign({}, extraParams, e.detail.data),
      )
    })

    this.el.addEventListener("input", (e) => {
      if (e.target.value === "") {
        this.pushEventTo(this.el, this.el.dataset.onClear, extraParams)
      }
    })

    // Pass the element so we can get fresh bias coordinates on each search
    initAutocomplete(this.el)

    // Listen for events from LiveView to update the hidden input
    this.handleEvent("update-submarket-input", ({ id, field, value }) => {
      // Find the hidden input in the parent component
      const hiddenInput = document.querySelector(
        `#${id} input[name="details_form[${field}]"]`,
      )
      if (hiddenInput) {
        hiddenInput.value = value
        // Trigger change event so the form knows about the update
        hiddenInput.dispatchEvent(new Event("change", { bubbles: true }))
      }
    })
  },
}

async function initAutocomplete(element) {
  const [
    { AutocompleteSessionToken, AutocompleteSuggestion },
    { LatLng, LatLngBounds },
  ] = await Promise.all([
    googleMapsLoader.importLibrary("places"),
    googleMapsLoader.importLibrary("core"),
  ])

  // Create new session token for each search session
  let autocompleteSessionToken = new AutocompleteSessionToken()

  window.fetchNeighborhoodsForAutocomplete ||= async (query) => {
    if (query === "") return []

    const requestParams = {
      input: query,
      sessionToken: autocompleteSessionToken,
      // Locality first, neighborhood last = neighborhood has highest priority
      includedPrimaryTypes: ["locality", "neighborhood"],
    }

    // Get fresh location restriction from data attributes each time
    const lat = parseFloat(element.dataset.biasLat)
    const lng = parseFloat(element.dataset.biasLng)

    if (!isNaN(lat) && !isNaN(lng)) {
      // Create bounding box around the city
      const sw = new LatLng(lat - 0.5, lng - 0.5)
      const ne = new LatLng(lat + 0.5, lng + 0.5)
      requestParams.locationRestriction = new LatLngBounds(sw, ne)
    }

    const { suggestions } =
      await AutocompleteSuggestion.fetchAutocompleteSuggestions(requestParams)

    // Refresh session token after each successful search per Google API docs
    autocompleteSessionToken = new AutocompleteSessionToken()

    return suggestions.map((s) => s.placePrediction).map(predictionMapper)
  }

  // Enable inputs marked for autocomplete initialization
  enableNeighborhoodSelector()
}

const selectorQuery = '[data-neighborhood-autocomplete-init="true"]'
function enableNeighborhoodSelector() {
  document.querySelectorAll(selectorQuery).forEach((input) => {
    input.removeAttribute("disabled")
  })
}
